import { useEffect, useState } from 'react';

interface ElectronEnvironment {
  isElectron: boolean;
}

const detectElectron = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return Boolean((window as any).platform?.isElectron);
  } catch (error) {
    console.warn('Failed to detect Electron platform information:', error);
    return false;
  }
};

export const useElectronEnvironment = (): ElectronEnvironment => {
  const [isElectron, setIsElectron] = useState<boolean>(() => detectElectron());

  useEffect(() => {
    setIsElectron(detectElectron());
  }, []);

  return { isElectron };
};

export default useElectronEnvironment;
